document.addEventListener('DOMContentLoaded', () => {
  // The Non Refundable Deposit tooltip is rendered in two locations: one mobile specific, one desktop specific
  const mobileWrappers = document.querySelectorAll('.mobile .tooltip-wrapper');
  const mobileTooltips = document.querySelectorAll('.mobile .tooltip-outter');
  const desktopWrappers = document.querySelectorAll('.desktop .tooltip-wrapper');
  const desktopTooltips = document.querySelectorAll('.desktop .tooltip-outter');

  // Desktop: show tooltip on hover
  desktopWrappers.forEach((wrapper, index) => {
    wrapper.addEventListener('mouseover', () => {
      showTooltip(desktopTooltips[index]);
    });
    wrapper.addEventListener('mouseout', () => {
      hideTooltip(desktopTooltips[index]);
    });
  });

  // Mobile: show tooltip on click
  mobileWrappers.forEach((wrapper, index) => {
    wrapper.addEventListener('click', (e) => {
      // Prevents the click event from reaching the document and triggering a hide action
      e.stopPropagation();

      if (mobileTooltips[index].classList.contains('show')) {
        hideTooltip(mobileTooltips[index]);
      } else {
        showTooltip(mobileTooltips[index]);
      }
    });
  });

  // Hide tooltip when clicking outside of it on mobile
  if (window.innerWidth < 835) {
    document.addEventListener('click', (e) => {
      mobileWrappers.forEach((wrapper, index) => {
        if (!e.target.closest(`.mobile ${wrapper.className}`)) {
          hideTooltip(mobileTooltips[index]);
        }
      });
    });
  }

  // Show tooltip
  function showTooltip(el) {
    el.classList.add('show');
  }

  // Hide tooltip
  function hideTooltip(el) {
    el.classList.remove('show');
  }
});
